/* Movatic WMS — Frontend | CesarFilho 932048016 | src/pages/workforce/ParkingSpots.tsx */
import React from 'react'

export default function WorkforceParkingSpots() {
    return (
        <div className="card p-4">
            <h2 className="text-lg font-semibold">Workforce • Parking Spots</h2>
            <p className="text-sm text-neutral-600 dark:text-neutral-400 mt-2">
                Cadastro/endereçamento de vagas de estacionamento para equipamentos.
            </p>
            {/* TODO: integrar com /api/workforce/parking-spots/ */}
        </div>
    )
}
